// Viewport density: true when the window is shorter than the trigger, so compact
// (dense) layouts can react. See CLAUDE.md "Client state ... store".
import ResizeObserver from 'resize-observer-polyfill';

import { createStore } from './create-store';

export const DENSE_HEIGHT_TRIGGER = 660;

export const computeDense = (clientHeight: number, trigger: number = DENSE_HEIGHT_TRIGGER): boolean =>
  clientHeight < trigger;

const initialHeight = typeof document !== 'undefined' ? document.body.clientHeight : DENSE_HEIGHT_TRIGGER;
const [useDenseStatus, getDenseValue, setIsDense] = createStore(computeDense(initialHeight));
export { useDenseStatus };

// Observe the body; flip density only when the value actually changes so no
// spurious re-render. Started on mount (see persist-gate), not at import.
let observer: ResizeObserver | null = null;
export const startViewportMonitoring = (): void => {
  if (observer || typeof document === 'undefined') return;
  observer = new ResizeObserver((entries) => {
    const nextDense = computeDense(entries[0].target.clientHeight);
    if (getDenseValue() !== nextDense) setIsDense(nextDense);
  });
  observer.observe(document.body);
};
